import { Skeleton } from '@aimsos/ui';

/**
 * Loading placeholder for the inbox list — one card-shaped skeleton per slot,
 * mirroring InboxListItem's layout (severity icon + title, a chips row, a meta
 * line) so the list keeps its shape while the fan-out resolves.
 */
function InboxListSkeleton({ count = 6 }) {
  return (
    <div className="flex flex-col gap-2" aria-busy="true" aria-live="polite">
      {Array.from({ length: count }).map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i} className="flex flex-col gap-2 rounded-[10px] border border-edge bg-surface px-3 py-2.5">
          <div className="flex items-start gap-2">
            <Skeleton width={24} height={24} borderRadius={6} />
            <Skeleton height={14} width="70%" />
          </div>
          <div className="flex items-center gap-1.5">
            <Skeleton width={56} height={16} borderRadius={9999} />
            <Skeleton width={40} height={16} borderRadius={9999} />
          </div>
          <Skeleton height={10} width="45%" />
        </div>
      ))}
    </div>
  );
}

export default InboxListSkeleton;
